import type { ReactNode } from 'react';
import { Sheet } from './Sheet.js';

export interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  variant?: 'bottom' | 'full';
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export function Modal({
  open,
  onClose,
  title,
  description,
  children,
  footer,
  className,
  variant,
  size = 'lg',
}: ModalProps) {
  return (
    <Sheet
      open={open}
      onClose={onClose}
      title={title}
      description={description}
      footer={footer}
      className={className}
      variant={variant}
      size={size}
    >
      {children}
    </Sheet>
  );
}
